"use strict";

window.addEventListener("DOMContentLoaded", function (event) {
  var headerNav = document.querySelector(".header");
  if (headerNav != null) {
    var menuItems = document.querySelectorAll("li.has-submenu");
    var overlay = document.querySelector(".dropdown-overlay");
    var closeSearchBtn = document.querySelector(".header__search");
    var closeSearchPanel = document.querySelector(".main-search-nav");
    menuItems.forEach(function (item) {
      item.addEventListener("click", function (e) {
        if (this.classList.contains("open")) {
          this.classList.remove("open");
          setAriaFalse();
          overlay.classList.remove("active-menu");
        } else {
          closeOpenMainMenuItems();
          this.classList.add("open");
          this.firstElementChild.setAttribute("aria-expanded", "true");
          overlay.classList.add("active-menu");
        }
        var htmlEl = document.getElementsByTagName("html")[0];
        htmlEl.classList.remove("mobile-open");

        // Closes search menu if open
        if (closeSearchBtn.classList.contains('active-search')) {
          closeSearchBtn.classList.remove('active-search');
          closeSearchBtn.setAttribute("aria-expanded", "false");
        }
        if (closeSearchPanel.classList.contains('active-search')) {
          closeSearchPanel.classList.remove('active-search');
        }
        e.stopPropagation();
      });
    });
    function closeOpenMainMenuItems() {
      var openMenus = document.querySelectorAll("li.has-submenu");
      openMenus.forEach(function (menus) {
        menus.classList.remove("open");
      });
      setAriaFalse();
      overlay.classList.remove("active-menu");
    }
    function setAriaFalse() {
      var ariaLink = document.querySelectorAll("li.has-submenu button.active-trigger");
      ariaLink.forEach(function (link) {
        link.setAttribute("aria-expanded", "false");
      });
    }
    var dropDownMenuItems = document.querySelectorAll(".drop-down");
    // Prevents menu from closing when clicked
    dropDownMenuItems.forEach(function (item) {
      item.addEventListener("click", function (e) {
        closeOpenMainMenuItems();
        e.stopPropagation();
      });
    });
    var closeMenu = document.querySelectorAll(".drop-down__close");
    // Close menu
    closeMenu.forEach(function (item) {
      item.addEventListener("click", function (e) {
        closeOpenMainMenuItems();
      });
    });
    var _headerNav = document.querySelector('.header__main-wrapper');
    var offset = _headerNav.offsetTop;
    var alertBox = document.querySelectorAll('.alert-container');
    var mobileMainNavigation = document.querySelector('.mobile-main-nav');
    if (alertBox.length > 0) {
      alertTotalHeight();
    }

    //Get the total height of each element
    function alertTotalHeight() {
      var total = 0;
      alertBox.forEach(function (item) {
        var itemHeight = item.offsetHeight;
        total = total + itemHeight;
        mobileMainNavigation.style.top = total + 'px';
      });
    }
    //Fixed Header Navigation 
    window.onscroll = function () {
      var scroll = window.scrollY;
      if (scroll >= offset) {
        _headerNav.classList.add("fixed-header");
        if (alertBox.length > 0) {
          mobileMainNavigation.style.top = '0';
        }
      } else if (scroll <= offset) {
        _headerNav.classList.remove("fixed-header");
        if (alertBox.length > 0) {
          alertTotalHeight();
        }
      }
    };
    window.onresize = function () {
      if (alertBox.length > 0) {
        alertTotalHeight();
      }
    };
    var htmlEle = document.getElementsByTagName('html')[0];
    var mediaQueryAbove = window.matchMedia('(min-width: 1024px)');
    //Click outside of menu or search
    if (mediaQueryAbove.matches) {
      htmlEle.addEventListener("click", function (e) {
        var el = $(e.target),
          $myLinks = $("li.has-submenu");
        var ele = $(e.target),
          $mainSearch = $("div.main-search-nav");
        if (ele.is($mainSearch) || $mainSearch.has(ele).length) {
          return true;
        } else {
          $mainSearch.removeClass("active-search");
          closeSearchBtn.classList.remove("active-search");
          closeSearchBtn.setAttribute("aria-expanded", "false");
          overlay.classList.remove("active-menu");
          htmlEle.classList.remove("mobile-open");
        }
        if (el.is($myLinks) || $myLinks.has(el).length) {
          return true;
        } else {
          $myLinks.removeClass("open");
          setAriaFalse();
          overlay.classList.remove("active-menu");
          htmlEle.classList.remove("mobile-open");
        }
      });
    }
  }
});